import { client } from '$api-client/client.gen'
import qs from 'query-string'

client.setConfig({
  headers: {
    Accept: 'application/json',
  },
  credentials: 'include',
  baseUrl: import.meta.env.VITE_API_BASE_URL + '/api',
  querySerializer: (params) => {
    if (params && typeof params === 'object') {
      for (const key in params) {
        if (typeof params[key] === 'boolean') {
          params[key] = params[key] ? 1 : 0
        }
      }
    }
    return qs.stringify(params, { arrayFormat: 'bracket' })
  },
})


client.interceptors.request.use(async(request) => {

  await includeCsrfToken(request.headers)

  return request
})

async function includeCsrfToken (headers: Headers) {
  const getCsrfCookieValue = () => {
    const xsrfCookie = document.cookie.match(new RegExp('(^|;\\s*)(XSRF-TOKEN)=([^;]*)'))
    return xsrfCookie ? decodeURIComponent(xsrfCookie[3]) : null
  }

  let csrfValue = getCsrfCookieValue()

  if (!csrfValue) {
    await fetch(import.meta.env.VITE_API_BASE_URL + '/sanctum/csrf-cookie', {
      credentials: 'include',
    })

    csrfValue = getCsrfCookieValue()
  }

  if (csrfValue) {
    headers.set('X-XSRF-TOKEN', csrfValue)
  }

  return headers
}

export { client as httpClient }
